var exports = {
  "U": "x61f99309--7afd12--buttons",
};

module.exports = exports;
